import React, { useState } from "react"
import {
  Modal,
  Form,
  Input,
  Checkbox,
  Button,
  Space,
  Tooltip,
  Tag,
  Typography,
  Divider,
  Alert,
} from "antd"
import {
  StopOutlined,
  SaveOutlined,
  CloseOutlined,
  WarningOutlined,
  FileTextOutlined,
} from "@ant-design/icons"

const { TextArea } = Input
const { Text } = Typography

export const StopGasProject = ({ rowData, mainProps }) => {
  const [open, setOpen] = useState(false)
  const [form] = Form.useForm()

  const handleSubmit = async values => {
    const { onStopGasProject } = mainProps

    const mapToSave = {
      stopDes: values.stopDes,
      gpId: rowData.id,
      // ✅ فقط وقتی کاربر تیک بزنه وضعیت تغییر می‌کنه
      isStop: values.toggleStop
        ? !rowData.isStop
        : rowData.isStop,
    }

    await onStopGasProject(mapToSave)
    setOpen(false)
    form.resetFields()
  }

  const handleCancel = () => {
    setOpen(false)
    form.resetFields()
  }

  return (
    <>
      <Tooltip
        title={
          rowData.isStop
            ? `توقف شده: ${rowData.stopDes || "—"}`
            : "توقف پرونده"
        }
      >
        <Button
          type="text"
          size="small"
          icon={
            <StopOutlined
              style={{
                color: rowData.isStop ? "#ff4d4f" : "#bfbfbf",
                fontSize: 14,
              }}
            />
          }
          onClick={() => {
            form.setFieldsValue({
              stopDes: rowData.stopDes || "",
              toggleStop: false, // ✅ پیش‌فرض: هیچ تغییری انجام نشود
            })
            setOpen(true)
          }}
          style={{
            borderRadius: 6,
            background: rowData.isStop ? "#fff1f0" : "transparent",
            border: rowData.isStop ? "1px solid #ffa39e" : "1px solid #d9d9d9",
            padding: "2px 8px",
            height: "auto",
          }}
        >
          <Text
            style={{
              fontSize: 10,
              color: rowData.isStop ? "#cf1322" : "#8c8c8c",
              fontWeight: rowData.isStop ? 600 : 400,
            }}
          >
            {rowData.isStop ? "متوقف" : "توقف"}
          </Text>
        </Button>
      </Tooltip>

      <Modal
        open={open}
        onCancel={handleCancel}
        footer={null}
        width={600}
        centered
        destroyOnClose
        style={{ direction: "rtl" }}
      >
        <div style={{ padding: "8px 0" }}>
          {/* Header */}
          <Space
            direction="vertical"
            size={12}
            style={{ width: "100%", marginBottom: 24 }}
          >
            <Space align="center" size={12}>
              <StopOutlined
                style={{
                  fontSize: 32,
                  color: rowData.isStop ? "#52c41a" : "#ff4d4f",
                }}
              />
              <div>
                <Text strong style={{ fontSize: 18, display: "block" }}>
                  {rowData.isStop
                    ? "رفع توقف پرونده"
                    : "توقف پرونده"}
                </Text>

                <Space size={8} style={{ marginTop: 4 }}>
                  <FileTextOutlined style={{ color: "#8c8c8c" }} />
                  <Text type="secondary">شماره پرونده:</Text>
                  <Tag color="blue" style={{ fontFamily: "tahoma" }}>
                    {rowData.fileNumber}
                  </Tag>
                </Space>
              </div>
            </Space>

            <Divider style={{ margin: "12px 0" }} />

            {rowData.isStop && (
              <Alert
                message="این پرونده در حال حاضر متوقف شده است"
                description={
                  rowData.stopDes && (
                    <div style={{ marginTop: 8 }}>
                      <Text type="secondary">دلیل توقف قبلی:</Text>
                      <div
                        style={{
                          background: "#f5f5f5",
                          padding: "8px 12px",
                          borderRadius: 6,
                          marginTop: 4,
                        }}
                      >
                        {rowData.stopDes}
                      </div>
                    </div>
                  )
                }
                type="warning"
                icon={<WarningOutlined />}
                showIcon
              />
            )}
          </Space>

          {/* Form */}
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
          >
            <Form.Item
              name="stopDes"
              label={
                <Space>
                  <FileTextOutlined />
                  <span>توضیحات</span>
                </Space>
              }
              rules={[
                {
                  required: true,
                  message: "لطفاً توضیحات را وارد کنید",
                },
                {
                  min: 10,
                  message: "حداقل 10 کاراکتر",
                },
              ]}
            >
              <TextArea
                rows={6}
                placeholder="توضیحات را کامل وارد کنید..."
                showCount
                maxLength={500}
                style={{
                  borderRadius: 8,
                  fontSize: 13,
                }}
              />
            </Form.Item>

            <Form.Item name="toggleStop" valuePropName="checked">
              <Checkbox
                style={{
                  fontSize: 14,
                  padding: "10px 12px",
                  background: rowData.isStop ? "#f6ffed" : "#fff2e8",
                  borderRadius: 8,
                  border: `1px solid ${
                    rowData.isStop ? "#b7eb8f" : "#ffd591"
                  }`,
                  width: "100%",
                }}
              >
                <Space>
                  <StopOutlined
                    style={{
                      color: rowData.isStop ? "#52c41a" : "#fa8c16",
                    }}
                  />
                  <Text strong>
                    {rowData.isStop
                      ? "رفع توقف (فعال‌سازی پرونده)"
                      : "توقف کردن پرونده"}
                  </Text>
                </Space>
              </Checkbox>
            </Form.Item>

            {/* Actions */}
            <Form.Item style={{ marginTop: 24, marginBottom: 0 }}>
              <Space style={{ width: "100%", justifyContent: "flex-end" }}>
                <Button
                  icon={<CloseOutlined />}
                  onClick={handleCancel}
                  size="large"
                  style={{ borderRadius: 8 }}
                >
                  انصراف
                </Button>

                <Button
                  type="primary"
                  htmlType="submit"
                  icon={<SaveOutlined />}
                  loading={mainProps.loading}
                  size="large"
                  style={{
                    borderRadius: 8,
                    minWidth: 120,
                  }}
                >
                  ذخیره تغییرات
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </>
  )
}